import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import Field from 'redux-form/es/Field';
import InputSelectField from 'components/Credit24/Core/Controls/InputSelectField';
import InputField from 'components/Credit24/Core/Controls/InputField';
import InputGoogleLocation from 'components/common/controls/InputGoogleLocation';
import Button from 'components/common/Button';
import { useApplicationFlags } from 'hooks/useApplicationFlags';
import { useTranslationSuffix } from 'hooks/useTranslationSuffix';

const propTypes = {
  toggleAddressDetails: PropTypes.func.isRequired,
  areAddressDetailsHidden: PropTypes.bool.isRequired,
  residenceTypes: PropTypes.array,
  states: PropTypes.array.isRequired,
  onSuggestSelected: PropTypes.func.isRequired,
};

const AddressDetailsAU = (props) => {
  const { isOcmOrUpgrade } = useApplicationFlags();

  const { areAddressDetailsHidden } = props;
  const detailsClasses = cx({
    grid: true,
    hide: areAddressDetailsHidden,
  });

  const title = useTranslationSuffix('upgrade', 'address_details.title');

  return (
    <div className="loan-form__step">
      <h1 className="loan-form__step-title">
        <FormattedMessage id={title} />
      </h1>
      <div className="loan-form__step-body">
        {isOcmOrUpgrade && (
          <Field
            emptyTextKey="address_details.field.residentialStatus"
            name="residentialStatus"
            component={InputSelectField}
            options={props.residenceTypes}
            isFullWidth
          />
        )}
        <div className="grid">
          <div className="grid__item three-quarters palm-one-whole">
            <div className={!areAddressDetailsHidden ? 'hide' : ''}>
              <Field
                name="geoAddress"
                title={<FormattedMessage id="customer.address.find" />}
                component={InputGoogleLocation}
                onSuggestSelected={props.onSuggestSelected}
              />
            </div>
          </div>
          <div className="grid__item one-quarter palm-one-whole">
            <Button
              btnType="secondary"
              type="button"
              onClick={props.toggleAddressDetails}
              isFullWidth
            >
              <FormattedMessage
                id={areAddressDetailsHidden
                  ? 'customer.address.details.show'
                  : 'customer.address.details.hide'}
              />
            </Button>
          </div>
        </div>
        <div className={detailsClasses}>
          <div className="grid__item one-quarter palm-one-half">
            <Field
              title={<FormattedMessage id="customer.field.unitNumber" />}
              name="unitNumber"
              type="text"
              component={InputField}
              isFullWidth
            />
          </div>
          <div className="grid__item one-quarter palm-one-half">
            <Field
              title={<FormattedMessage id="customer.field.streetNumber" />}
              name="streetNumber"
              type="text"
              component={InputField}
              isFullWidth
            />
          </div>
          <div className="grid__item one-half palm-one-whole">
            <Field
              title={<FormattedMessage id="customer.field.street" />}
              name="street"
              type="text"
              component={InputField}
              isFullWidth
            />
          </div>
          <div className="grid__item one-half palm-one-whole">
            <Field
              title={<FormattedMessage id="customer.field.city" />}
              name="city"
              type="text"
              component={InputField}
              isFullWidth
            />
          </div>
          <div className="grid__item one-half palm-one-whole">
            <Field
              emptyTextKey="customer.field.state"
              name="addressState"
              component={InputSelectField}
              options={props.states}
              isFullWidth
            />
          </div>
          <div className="grid__item one-half palm-one-whole">
            <Field
              title={<FormattedMessage id="customer.field.postCode" />}
              name="postCode"
              type="text"
              component={InputField}
              mask="9999"
              maskChar="_"
              isFullWidth
              isMaskedInput
            />
          </div>
        </div>
      </div>
    </div>
  );
};

AddressDetailsAU.propTypes = propTypes;

export default AddressDetailsAU;
